/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc
 */

export let ComHubspotBuyingModelsRpcProductAbstractProductRpcError;
(function (_ComHubspotBuyingModelsRpcProductAbstractProductRpcError) {})(ComHubspotBuyingModelsRpcProductAbstractProductRpcError || (ComHubspotBuyingModelsRpcProductAbstractProductRpcError = {}));
export let ComHubspotBuyingModelsRpcProductPortalstateAbstractPortalStateWithUsageError;
(function (_ComHubspotBuyingModelsRpcProductPortalstateAbstractPortalStateWithUsageError) {})(ComHubspotBuyingModelsRpcProductPortalstateAbstractPortalStateWithUsageError || (ComHubspotBuyingModelsRpcProductPortalstateAbstractPortalStateWithUsageError = {}));
export let ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError;
(function (_ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError) {})(ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError || (ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError = {}));
export const getProductsRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getProducts',
  auth: 'external',
  fingerprint: 'X2gyY1_5noF8ic51ILFzTZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getProductsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getProductsV2',
  auth: 'external',
  fingerprint: 'X2gyY1_5noF8ic51ILFzTWHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getProductInventoryRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getProductInventory',
  auth: 'external',
  fingerprint: 'AAAAAAAAAAAw7e7WvkfZNpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getProductInventoryV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getProductInventoryV2',
  auth: 'external',
  fingerprint: 'AAAAAAAAAAAw7e7WvkfZNmHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSeatsProductInventoryV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getSeatsProductInventoryV2',
  auth: 'external',
  fingerprint: 'AAAAAAAAAACHTP33O5UJ5GHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOwnedProductsRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getOwnedProducts',
  auth: 'external',
  fingerprint: 'AAAAAAAAAABTQrKlhHU4ipwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAddOnsRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getAddOns',
  auth: 'external',
  fingerprint: 'vGIOyRUOOtAcTK6AliWoS5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAddOnsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getAddOnsV2',
  auth: 'external',
  fingerprint: 'vGIOyRUOOtAcTK6AliWoS2HrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getGrowthPurchaseOptionsRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getGrowthPurchaseOptions',
  auth: 'external',
  fingerprint: 'pVh7oN-TcNvNcgDdIob235wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getGrowthPurchaseOptionsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getGrowthPurchaseOptionsV2',
  auth: 'external',
  fingerprint: 'KTof_xqYSCjNcgDdIob232HrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOwnedQuantitiesRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getOwnedQuantities',
  auth: 'external',
  fingerprint: 'xMTB05LzVwrgqCyvfBEaQZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOwnedQuantitiesV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getOwnedQuantitiesV2',
  auth: 'external',
  fingerprint: 'xMTB05LzVwrgqCyvfBEaQWHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCurrencyRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getCurrency',
  auth: 'external',
  fingerprint: 'AAAAAAAAAADR3W4J-ZD9V0IvbGFwJ20M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCurrencyV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getCurrencyV2',
  auth: 'external',
  fingerprint: 'AAAAAAAAAADR3W4J-ZD9V2HrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getFeatureFlagsRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getFeatureFlags',
  auth: 'external',
  fingerprint: 'AAAAAAAAAAA9llyZwSnPm0IvbGFwJ20M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getFeatureFlagsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getFeatureFlagsV2',
  auth: 'external',
  fingerprint: 'AAAAAAAAAAA9llyZwSnPm2HrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInAppPhoneNumberRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getInAppPhoneNumber',
  auth: 'external',
  fingerprint: 'ii4zwAPZgvSJvnxBO5sLIWHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInAppProductBadgesRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getInAppProductBadges',
  auth: 'external',
  fingerprint: '08RwPDYX0FPpwqK0OaEJumHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInAppProductTierOptionsRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getInAppProductTierOptions',
  auth: 'external',
  fingerprint: 'YK2pT9shSckG9sMJRLb8imHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInAppProductPlanRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getInAppProductPlan',
  auth: 'external',
  fingerprint: '5deaiwG5W8Q3o48oTQK_tWHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalStateWithUsageRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getPortalStateWithUsage',
  auth: 'external',
  fingerprint: '-Pe5y3zf_Th5ACY9kcFRIIk5qL9wqpvQ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInAppProductConfigRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getInAppProductConfig',
  auth: 'external',
  fingerprint: 'iMuCCFKJZPMV5_N7_CHzdWHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};